import {
    ROUTE
    //tracker
} from "../../Components/misc";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { Tab, TabContent, TabData, TabVariant } from "../Container";
import {
    AboutPageContainer,
    // DynamicPageRouter,
    ExplorerPageContainer,
    FAQPageContainer,
    OverviewPageContainer
} from "../DynamicPageRouter";
import ReactResizeDetector from "react-resize-detector";
import styles from "./PageMainTab.module.scss";
import { AllProvidersRequestor } from "../AllProvidersRequestor";

export type PageMainTabValue = "overview" | "explore" | "faq" | "about";

export interface PageMainTabDefinition extends TabData {
    id: PageMainTabValue;
}

export interface PageMainTabProps {
    activeTabId?: PageMainTabValue;
    exploreDisplayOption?: "search" | "providerInfo" | "providerSelectToCompare" | "providerCompare";
    variant?: TabVariant;
}
const LPageMainTab: React.FC<PageMainTabProps> = ({ activeTabId = "overview", variant, exploreDisplayOption }) => {
    const history = useHistory();
    const tabData = React.useMemo<PageMainTabDefinition[]>(() => {
        return [
            {
                id: "overview",
                title: "Overview",
                shortTitle: "Overview"
            },
            {
                id: "explore",
                title: "Explore providers",
                shortTitle: "Explore providers"
            },
            {
                id: "faq",
                title: "Queensland’s Urban Water Sector",
                shortTitle: "Queensland’s Urban Water Sector"
            },
            {
                id: "about",
                title: "About the Explorer",
                shortTitle: "About the Explorer"
            }
        ];
    }, []);

    const onTabClick = useCallback(
        (tab: PageMainTabDefinition) => {
            if (tab.id === "overview") {
                history.push(ROUTE.HOME);
            } else if (tab.id === "explore") {
                // if (tracker?.providerPageNavHistoryIndex == null) {
                history.push(ROUTE.SEARCH_PAGE);
                // } else {
                //     history.push(tracker?.providerPageNavHistoryIndex);
                // }
            } else if (tab.id === "faq") {
                history.push(ROUTE.FAQ);
            } else if (tab.id === "about") {
                history.push(ROUTE.ABOUT);
            }
        },
        [history]
    );

    return (
        <Tab
            tabData={tabData}
            activeId={activeTabId}
            className={`${styles.pageMainTab} ${styles[variant] ?? ""} page-main-tab`}
            variant={variant}
        >
            <TabContent id="overview" onClick={onTabClick}>
                <AllProvidersRequestor>
                    <div className={`container ${styles.appContainer}`}>
                        <OverviewPageContainer />
                    </div>
                </AllProvidersRequestor>
            </TabContent>
            <TabContent id="explore" onClick={onTabClick}>
                <AllProvidersRequestor>
                    <div className={`container ${styles.appContainer}`}>
                        {/* <SearchPageContainer /> */}
                        <ExplorerPageContainer page={exploreDisplayOption} />
                    </div>
                </AllProvidersRequestor>
            </TabContent>
            <TabContent id="faq" onClick={onTabClick}>
                <div className={`container ${styles.appContainer}`}>
                    <FAQPageContainer />
                </div>
            </TabContent>
            <TabContent id="about" onClick={onTabClick}>
                <div className={`container ${styles.appContainer}`}>
                    <AboutPageContainer />
                </div>
            </TabContent>
        </Tab>
    );
};

// const _PageMainTabWithHamburger: React.FC<TabProps> = ({ className, tabData, activeId, variant, children }) => {
//     const [open, setOpen] = useState(false);
//     const onClick = useCallback(() => {
//         setOpen(!open);
//     }, [open]);

//     return (
//         <div className={`${styles.hamburgerTab}`}>
//             <div className={styles.menu}>
//                 <div className={styles.hamburger} onClick={onClick}>
//                     <div>Menu</div>
//                     <MenuButton open={open} />
//                 </div>
//                 <div className={styles.menuContent}></div>
//             </div>
//             <div className={styles.content}></div>
//         </div>
//     );
// };
export const PageMainTab: React.FC<PageMainTabProps> = props => {
    const ref = useRef<HTMLDivElement>();
    const [showNormalMenu, setShowNormalMenu] = useState(undefined);

    const onResize = useCallback(() => {
        if (ref.current) {
            const width = ref.current?.clientWidth;
            if (width <= 1050) setShowNormalMenu(false);
            else {
                setShowNormalMenu(true);
            }
        }
    }, []);

    useEffect(() => {
        onResize();
    }, [onResize]);

    return (
        <>
            <div ref={ref}>
                <ReactResizeDetector handleWidth={true} onResize={onResize} />
            </div>
            <LPageMainTab {...props} variant={showNormalMenu === false ? "hamburger" : undefined}></LPageMainTab>
        </>
    );
};
